var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-4 lg:py-6 px-3 lg:px-6"},[_c('h1',{staticClass:"text-green-500 text-3xl font-semibold"},[_vm._v("Gadget Policies")]),_c('approvals-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }